var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPlaceholder = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.307,
    height: 16.156,
    viewBox: "0 0 12.307 16.156",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M71.887,15.21H68.1c4.2-5.595,5.207-6.487,5.207-9.056A6.153,6.153,0,0,0,61,6.153c0,2.566,1,3.45,5.207,9.056H62.42a.473.473,0,1,0,0,.947h9.467a.473.473,0,0,0,0-.947ZM62.893,6.153a4.26,4.26,0,1,1,8.52,0,4.26,4.26,0,1,1-8.52,0Z",
    transform: "translate(-61)",
    fill: "#09819a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.26 3.787)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M197.893,120a1.893,1.893,0,1,0,1.893,1.893A1.9,1.9,0,0,0,197.893,120Z",
    transform: "translate(-196 -120)",
    fill: "#09819a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.616 7.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M180.215,240a2.806,2.806,0,0,1-4.2,0,2.917,2.917,0,0,0-.436.66,3.227,3.227,0,0,0,5.076,0A2.916,2.916,0,0,0,180.215,240Z",
    transform: "translate(-175.576 -240)",
    fill: "#09819a"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlaceholder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/placeholder.b333d3d9.svg";
export { ForwardRef as ReactComponent };